<div (click)='toggle()' class='iconInformation'>
    <div class='iconInformation__block'>
        <div class="icon">
            <mat-icon [svgIcon]="'show-more'" color="accent"  *ngIf="!expanded"></mat-icon>
            <mat-icon [svgIcon]="'show-less'" color="primary"  *ngIf="expanded"></mat-icon>
        </div>
        <div class='iconInformation__block__information'>
            <div class='iconInformation__block__information__title' [innerHtml]="_title | safeHtml">
            </div>
            <!-- TODO esto debería ser un componente por sí mismo-->
            <div *ngIf="expanded" class='iconInformation__block__information__paragraph'>
                <div [innerHtml]="_paragraphs | safeHtml"><div>
                
            </div>
        </div>
    </div>
    <mat-divider class='iconInformation__divider'></mat-divider>
</div>